module.exports = __webpack_public_path__ + "static/media/icon-add-video.32efadcb.svg";